
import React from "react"
import Image from "@components/image"

const PressSlider = ({ pressSlides, slides, sliderSettings, }) => {
  let sliderItems = pressSlides || slides;
  return (
      <div className="w-full py-14 md:py-16 mx-auto text-center overflow-x-scroll scrolling-touch rounded-xl flex">
      {sliderItems?.map((slide, i) => (
        <div key={i} className="px-5 md:px-10 mx-0">
          <Image
            className="pt-200 max-h-7 max-w-[200px]"
            objectFit="contain"
            image={slide.image}
          />
          <p
            aria-label={slide.content?.replace(/\n/g, ' ')}
            className="mx-auto text-sm md:text-lg mt-5 sm:w-full whitespace-nowrap"
            key={slide._key}
            dangerouslySetInnerHTML={{ __html: slide.content?.replace(/\n/g, '<br>') }}
          >
          </p>
        </div>
      ))}
      </div>
  )
}

export default PressSlider